import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  APIErrorResponse,
  InternalHoursLog,
  PostInternalHoursLog,
} from '@/types'
import { getUseInternalHoursLogsKey } from './useInternalHoursLogs'

export const usePostInternalHoursLog = (): UseMutationResult<
  InternalHoursLog,
  APIErrorResponse,
  PostInternalHoursLog
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseInternalHoursLogsKey()

  return useMutation(
    (params) =>
      client
        .post('/hours_reporting/internal-hours/', params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(listKey)
      },
    }
  )
}
